import produce from "immer";

import { Action, actionCreators } from "../actions";

const initialStore = {
    version: undefined as string | undefined,
};

type Store = Readonly<typeof initialStore>;

export const update = produce((draft, action: Action): Store | void => {
    if (action.type === actionCreators.setElectronVersion.type) {
        draft.version = action.payload.version;
    }
}, initialStore);

export type OuterStore = { electronIntegration: Store };

export function getElectronVersion(store: OuterStore) {
    return store.electronIntegration.version;
}
